import { types } from "../Helpers/Types";

// Define el estado inicial
const initialState = {
    notifications: [],
    unreadCount: 0
};

export const NotificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'ADD_NOTIFICATION':
            return {
                ...state,
                notifications: [action.payload, ...state.notifications],
                unreadCount: state.unreadCount + 1
            };
        case 'SET_NOTIFICATIONS':
            return {
                ...state,
                notifications: action.payload,
                unreadCount: action.payload.length
            };
        case 'RESET_UNREAD_COUNT': // Nuevo caso para resetear el contador
            return {
                ...state,
                unreadCount: 0
            };
        default:
            return state;
    }
};
